export default __webpack_public_path__ + "static/media/CapaFileImage.9cbd9626.svg";